<p-toast></p-toast>
<div class="splash-screen account-wrapper-screen"></div>
<div class="account-wrapper ui-g" style="z-index: 100">
  <div class="card login-panel">
    <div class="ui-g">
      <div class="ui-col-12 ui-g-12 logo-wrapper">
        <img [src]="logoSrc" [alt]="logoAlt" class="login-logo" />
        <div class="line-separator"></div>
      </div>

      <div class="background-image"></div>
      <div class="foreground-image"></div>

      <!--<maintenance></maintenance>-->
      <router-outlet></router-outlet>
    </div>
  </div>
  <div style="clear: both"></div>
</div>
